module.exports = __webpack_public_path__ + "static/media/godmother_banner.1d0add00.webp";